import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree} from "@angular/router";
import {combineLatest, Observable} from "rxjs";
import {NewUserComponent} from "src/app/features/login/new-user/new-user.component";
import {ModalService} from "../../services/modal.service";
import {AuthService} from "../../services/auth.service";
import {map, take} from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class LeaveFormGuard implements CanDeactivate<NewUserComponent> {

  private readonly allowedRoutes = [
    '/terms',
    '/user-profile',
    '/privacy',
    '/login/new-user',
    '/price-list',
  ];


  constructor(
    private modalService: ModalService,
    private authService: AuthService,
  ) {
  }

  canDeactivate(
    _component: NewUserComponent,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
  {

    // Block navigation if nextState unexpectedly doesn't exist
    if (!nextState) {
      return false;
    }

    const { url: nextUrl } = nextState;

    // Allow navigation for allowed routes
    if (this.allowedRoutes.some((route) => nextUrl.includes(route))) {
      return true;
    }

    return combineLatest([
      this.authService.isAuthenticated$(),
      this.authService.isNew$,
    ])
      .pipe(
        take(1),
        map(([isAuthenticated, isNew]) => {
          // Show modal if user is new and not authenticated
          if (!isAuthenticated && isNew) {
            this.modalService.showAreYouSureModal();
            return false;
          }
          // Allow navigation otherwise
          return true;
        }),
      );
  }
}
